import { render, staticRenderFns } from "./PaymentsTable.vue?vue&type=template&id=a5f66966&"
import script from "./PaymentsTable.vue?vue&type=script&lang=ts&"
export * from "./PaymentsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports